import "./styles.scss"

import React, { useState, useEffect } from "react"
import clsx from "clsx"

import { useLocale } from "context/locale"

import WebinityBadge from "components/WebinityBadge"

const variants = ["main", "light", "dark", "mono", "bordered"]

const Badge = () => {
  const { lang } = useLocale()

  const [badgeVariant, setBadgeVariant] = useState("main")
  const [password, setPassword] = useState("")
  const [isUnlocked, setIsUnlocked] = useState(false)

  useEffect(() => {
    const handler = e => {
      const key = e.key

      setPassword(prevPassword => prevPassword + key)
    }

    window.addEventListener("keydown", handler)

    return () => window.removeEventListener("keydown", handler)
  })

  useEffect(() => {
    let timeout

    if (password === "badge") {
      setIsUnlocked(true)
    }

    clearTimeout(timeout)

    timeout = setTimeout(() => {
      setPassword("")
    }, 2000)
  }, [password])

  return (
    isUnlocked && (
      <div className="badge-preview">
        <WebinityBadge variant={badgeVariant} lang={lang} />
        <ul className="badge-preview__list">
          {variants.map((variant, index) => (
            <li key={index}>
              <button
                className={clsx(badgeVariant === variant && "active")}
                type="button"
                onClick={() => setBadgeVariant(variant)}
              >
                {index + 1}
              </button>
            </li>
          ))}
        </ul>
      </div>
    )
  )
}

export default Badge
